import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    data: {
      title: 'Dane',
      type: 'string',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
